export const API_TARGET = 'https://whee.pro';
export const IS_DEV_API = API_TARGET.includes('wheedev');
